import { render, staticRenderFns } from "./MessagesWindow.vue?vue&type=template&id=fe3ef5a6&scoped=true&"
import script from "./MessagesWindow.vue?vue&type=script&lang=js&"
export * from "./MessagesWindow.vue?vue&type=script&lang=js&"
import style0 from "./MessagesWindow.vue?vue&type=style&index=0&id=fe3ef5a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3ef5a6",
  null
  
)

export default component.exports